const statusModule = {
  payStatus0: "未支払",
  payStatus1: "支払済",
  payStatus3: "返金済",
  payStatus4: "返金失敗",
  "orderStatus-1": "キャンセル",
  orderStatus0: "未処理",
  orderStatus1: "受付済",
  orderStatus2: "完了",
  orderAll: "全部",
  payFun3: "店頭払い",
  payFun3_1: "着払い",
  Monday: "月",
  Tuesday: "火",
  Wednesday: "水",
  Thursday: "木",
  Friday: "金",
  Saturday: "土",
  Sunday: "日",
  zhuri: '祝日',
  sex0: "非公開",
  sex1: "男",
  sex2: "女",
  loading: "読み込み中",
  noMore: "データが見つかりません",
  feedbackType0: "ご注文について",
  feedbackType1: "会員情報について",
  feedbackType2: "ご利用方法について",
  feedbackType3: "その他",
  payType1: "WechatPay",
  payType2: "Alipay",
  payType3: "クレジットカード"
};
export default statusModule;
